module.exports = __webpack_public_path__ + "img/2.f9f6bbd.png";